import { apiFetch } from "#lib/api";

export interface Creator {
  id: string;
  name: string;
  service: string;
  indexed: string;
  updated: string;
  public_id: string | null;
  relation_id: number | null;
  has_chats: boolean;
  post_count: number;
  dm_count: number;
  share_count: number;
  chat_count: number;
}

export interface CreatorWithFavs extends Creator {
  count: number;
  favorited: number
}

export async function fetchCreator(service: string, creatorId: string): Promise<Creator> {
  const path = `/${service}/user/${creatorId}/profile`;
  return await apiFetch<Creator>(path);
}
